import React from "react";
import PropTypes from "prop-types";
import { currencyType } from "custom-prop-types";
import { CurrencyTaxLanguageForm } from "components/settings/currency-tax-language-form";

export const CurrencyTaxLanguageSettings = ({
  currency,
  currencies,
  locale,
  onSaveCurrencyLocaleTax,
  showUniversalCategorySet,
  supportedLocales,
  vat
}) => {
  const mappedLocale = localeValueMapper(locale);
  const mappedCurrency = currencyValueMapper(currency);
  const tax = vat;
  const initialValues = {
    currency: mappedCurrency,
    vat: tax,
    locale: mappedLocale,
    isDefaultCategories: showUniversalCategorySet
  };
  return (
    <div>
      <h1>Currency Tax and Language Settings</h1>
      <CurrencyTaxLanguageForm
        currencies={ currencies }
        initialValues={ initialValues }
        onSaveCurrencyLocaleTax={ onSaveCurrencyLocaleTax }
        supportedLocales={ supportedLocales }
      />
    </div>
  );
};

CurrencyTaxLanguageSettings.propTypes = {
  currencies: PropTypes.arrayOf(currencyType).isRequired,
  currency: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  onSaveCurrencyLocaleTax: PropTypes.func.isRequired,
  showUniversalCategorySet: PropTypes.bool.isRequired,
  supportedLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
  vat: PropTypes.number.isRequired
};

const currencyValueMapper = (value) => ({ key: value, name: value });
const localeValueMapper = (value) => ({ key: value, name: `English (${localeToCountry(value)})` });
const localeToCountry = (locale) => locale.split("-").pop();



// WEBPACK FOOTER //
// ./src/js/components/settings/currency-tax-language-settings.jsx